<template>
  <div>
    <router-link class="font-weight-bold"
                 v-if="!isPatient && object.status != 2 && !object.isOtherBranch && object.client_id"
                 :to="{name: 'PatientVisitPage', params: { visitid: object.id, id: object.client_id, page: 'teeth' } }">
      <div>{{ periodString }}</div>
    </router-link>
    <div v-else>
      {{ periodString }}
    </div>
  </div>
</template>

<script setup>
import { formatDate } from "@/extensions/filters/filters"
import {computed} from "vue"
import {useStore} from "vuex"

const store = useStore()

const props = defineProps({
  object: {
    type: Object
  }
})

const periodString = computed(() => {
  return `${formatDate(props.object.start, 'DD.MM.YY, HH:mm')} - ${formatDate(props.object.end, 'HH:mm')}`
})

const isPatient =  computed(() => {
  return store.getters.isPatient
})
</script>
